module.exports = __webpack_public_path__ + "img/icon-search-inverted.9bf1330d.svg";